module.exports = {
  'axes': ['axes', 'axes'],
  'navigation': ['navigation', 'navigation'],
  'acces_art': ['acces_art','acces_art'],
  'about': ['about', 'a-propos'],
  'tapestry': ['tapestry', 'tapisserie'],
  'contact': ['contact', 'contact'],
  'f2t': ['F2T','F2T']
};
